import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';
import { useCanvasRef } from './NodeContextProvider';
import SmoothStepEdge from './edges/SmoothStepEdge';

function EdgeRenderer(props) {
  const { id, edges } = props;

  const canvasRef = useCanvasRef();

  const [ready, setReady] = useState(false);
  const [, setRefresh] = useState(Date.now());

  const edgeDiv = useRef(null);

  useEffect(() => {
    setReady(true);
  }, []);

  useEffect(() => {
    setRefresh(Date.now());
    /* setTimeout(() => {
      console.log(edges.length, edgeDiv.current.childNodes[1].childNodes.length);
    }, 16); */
  }, [edges]);

  useEffect(() => {
    const resizeObserver = new ResizeObserver(() => {
      setRefresh(Date.now());
    });
    resizeObserver.observe(canvasRef.current);
    return () => {
      resizeObserver.disconnect();
    };
  }, [canvasRef]);

  return (
    <div className="icp-workflow-edges" ref={edgeDiv}>
      <svg className="icp-workflow-marker">
        <defs>
          <marker
            id={`${id}__type=arrow`}
            markerWidth="20"
            markerHeight="20"
            viewBox="-10 -10 20 20"
            markerUnits="strokeWidth"
            orient="auto-start-reverse"
            refX="0"
            refY="0"
          >
            <polyline
              strokeLinecap="round"
              strokeLinejoin="round"
              fill="none"
              points="-5,-5 0,0 -5,5"
            />
          </marker>
        </defs>
      </svg>
      {ready ? (
        <svg>
          {edges.map((edge) => {
            return (
              <SmoothStepEdge
                key={`${edge.source}-${edge.target}`}
                edge={edge}
                workflowId={id}
                edgeDiv={edgeDiv}
              />
            );
          })}
        </svg>
      ) : null}
    </div>
  );
}

EdgeRenderer.propTypes = {
  id: PropTypes.string,
  edges: PropTypes.arrayOf(PropTypes.shape({})),
};

export default EdgeRenderer;
